import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { Badge, Card, Icon, IconButton, Tooltip, Grid } from "@mui/material";
import { Tabs } from "antd";
import SuiBox from "components/SuiBox";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiTypography from "components/SuiTypography";
import ContactAvatar from "components/UpStyled/ContactAvatar";
import Prompt from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import CounterContext from "context/counter";
import qs from "query-string";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import api from "services/api";
import { stringToColor } from "utils/color";
import ChatRoom, { RenderChatMenu } from "./chatroom";
const { TabPane } = Tabs;

function capitalize(s) {
  if (s && s.length > 0) return s[0].toUpperCase() + s.slice(1);
  return s;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 24,
      height: 24,
    },
    children: `${name && name.length > 0 ? name[0].toUpperCase() : "U"}`,
  };
}

const labelProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const MessagesPage = () => {
  let { inittab } = useParams();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  let initchatid = urlObj?.query.chatid ?? "";

  const [currentRoom, setCurrentRoom] = useState(null);
  const [roomlist, setRoomList] = useState([]);
  const [contactlist, setContactList] = useState([]);
  const [currentTab, setCurrentTab] = useState(inittab ?? "project");
  const [currentAccountType, setCurrentAccountType] = useState({ value: "all", label: "All" });
  const [currentProjectStatus, setCurrentProjectStatus] = useState({ value: "all", label: "All" });
  const [searchTxt, setSearchTxt] = useState("");
  const [searchStr, setSearchStr] = useState("");
  const [newGroupVisiable, setNewGroupVisiable] = useState(false);

  const msgcounter = useContext(CounterContext);
  const account = useContext(AccountContext);
  let userid = account.id;

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  const reloadChats = (clear = false) => {
    try {
      api.chatroom
        .listChatRoom(
          currentTab,
          currentTab == "general" ? currentAccountType.value : currentProjectStatus.value,
          ""
        )
        .then(({ data }) => {
          var result = data.chats;
          if (currentTab == "project" && searchStr)
            result = result.filter(
              (room) =>
                room.name.toLowerCase().includes(searchStr) ||
                room.regardingname.toLowerCase().includes(searchStr)
            );
          setRoomList(result);
          if (!currentRoom && initchatid) {
            for (const room of result) if (room.id == initchatid) setCurrentRoom(room);
          }
          return data;
        });
    } catch (err) {
      toast.error(`listChatRoom failed!`);
      console.log(err);
    }
    msgcounter.getNewMessageCount();
    if (clear) {
      setCurrentRoom(null);
    }
  };

  const reloadContacts = () => {
    if (currentTab == "general") {
      try {
        api.chatroom.listContacts(currentAccountType.value).then(({ data }) => {
          setContactList(data.contacts);
          return data;
        });
      } catch (err) {
        toast.error(`listContacts failed!`);
        console.log(err);
      }
    }
  };

  useEffect(() => {
    reloadChats();
    reloadContacts();
  }, [currentRoom, currentAccountType, currentProjectStatus, searchStr, currentTab]);

  const onChangeTab = (key) => {
    setCurrentTab(key);
    setCurrentRoom(null);
    setCurrentAccountType({ value: "all", label: "All" });
    setCurrentProjectStatus({ value: "all", label: "All" });
    setSearchTxt("");
    setSearchStr("");
  };

  const RenderAccountTypeMenu = () => {
    const types = [
      { value: "all", label: "All" },
      { value: "de", label: "Designers" },
      { value: "ma", label: "Manufacturers" },
    ];
    const handleClick = (option) => {
      setCurrentAccountType(option);
    };
    return (
      <SuiBox sx={{ width: "100%" }} mb={1} display="flex justify-between" alignItems="center">
        <SuiTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
        >
          Filter By:&nbsp;&nbsp;
        </SuiTypography>
        <SuiBox sx={{ width: "100%", height: "100%", pr: 15.5 }}>
          <SuiSelect
            size="medium"
            options={types.map((type) => ({
              value: type.value,
              label: type.label,
            }))}
            onChange={handleClick}
            value={currentAccountType}
          />
        </SuiBox>
      </SuiBox>
    );
  };

  const RenderProjectStatusMenu = () => {
    const types = [
      { value: "all", label: "All" },
      { value: "id", label: "Initial Draft" },
      { value: "re", label: "Request" },
      { value: "op", label: "Ongoing Projects" },
      { value: "fp", label: "Completed Projects" },
    ];
    const handleClick = (option) => {
      setCurrentProjectStatus(option);
    };
    return (
      <SuiBox sx={{ width: "100%" }} mb={1} display="flex justify-between" alignItems="center">
        <SuiBox alignItems="center">
          <SuiTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Filter By:&nbsp;&nbsp;
          </SuiTypography>
        </SuiBox>
        <SuiBox sx={{ width: "100%", height: "100%", pr: 15.5 }} alignItems="center">
          <SuiSelect
            size="medium"
            options={types.map((type) => ({
              value: type.value,
              label: type.label,
            }))}
            onChange={handleClick}
            value={currentProjectStatus}
          />
        </SuiBox>
      </SuiBox>
    );
  };

  const NewGroupPrompt = ({ visible, setVisible }) => {
    const [subject, setSubject] = useState("");
    const [contacts, setContacts] = useState([]);

    return (
      <Prompt
        heading="New group"
        option={{ maxWidth: "md", fullWidth: true }}
        text={
          <SuiBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
            <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                Group Subject
              </SuiTypography>
            </SuiBox>
            <SuiInput
              sx={{ minWidth: "480px" }}
              value={subject}
              minRows={1}
              maxRows={1}
              onChange={(e) => setSubject(e.target.value)}
            />
            <SuiBox mt={1} mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SuiTypography component="label" variant="caption" fontWeight="bold">
                Select Contacts
              </SuiTypography>
            </SuiBox>
            <SuiSelect
              isMulti
              size="medium"
              placeholder="Select Contact"
              className="grow"
              options={contactlist.map((contact) => ({
                value: contact.id,
                label: contact.name + " (" + contact.email + ")",
              }))}
              onChange={async (data) => {
                setContacts(data);
              }}
            />
          </SuiBox>
        }
        visible={visible}
        okText="Create"
        okColor="dark"
        handleOk={async () => {
          if (subject == "") {
            toast.error(`Please provide group subject!`);
            return;
          }
          if (contacts.length == 0) {
            toast.error(`Please provide contacts!`);
            return;
          }
          try {
            let userids = contacts.map((a) => a.value);
            const { data } = await api.chatroom.addChatRoom({
              userids: userids,
              name: subject,
            });
            setCurrentRoom(data);
          } catch (err) {
            toast.error(`addChatRoom failed!`);
            console.log(err);
            return;
          }
          setVisible(false);
        }}
        handleClose={() => setVisible(false)}
      />
    );
  };

  const smartdate = require("smartdate");
  smartdate.init();
  return (
    <Card className="h-fit">
      <div className="px-4 py-2">
        <Grid container alignItems="stretch">
          <Grid item xs={12} sm={12} md={4}>
            <Tabs defaultActiveKey={currentTab} onChange={onChangeTab} type="card">
              <TabPane
                tab={
                  <Badge
                    color="error"
                    badgeContent={msgcounter["pcount"]}
                    size="small"
                    invisible={msgcounter["pcount"] <= 0}
                  >
                    <SuiTypography variant="body1" textTransform="capitalize">
                      Project chats
                    </SuiTypography>
                  </Badge>
                }
                key="project"
              >
                <Card className="medium:col-span-1 small:col-span-1 xsmall:col-span-3 overflow-hidden">
                  <div className="p-2">
                    <RenderProjectStatusMenu />
                    <SuiBox display="flex justify-between" alignItems="center">
                      <div className="w-full pr-3 flex items-center">
                        <SuiInput
                          className="w-full grow"
                          size="medium"
                          value={searchTxt}
                          onChange={(event) => setSearchTxt(event.target.value)}
                          onKeyPress={(event) => {
                            if (event.key === "Enter") {
                              setSearchStr(searchTxt.toLowerCase());
                              event.preventDefault();
                            }
                          }}
                          onBlur={() => {
                            setSearchStr(searchTxt.toLowerCase());
                          }}
                          icon={{
                            component: searchStr ? (
                              <ClearIcon
                                onClick={() => {
                                  setSearchTxt("");
                                  setSearchStr("");
                                }}
                              />
                            ) : (
                              <SearchIcon />
                            ),
                            direction: "left",
                          }}
                        />
                        <IconButton
                          size="small"
                          variant="button"
                          color="inherit"
                          onClick={() => {
                            reloadChats();
                          }}
                        >
                          <Icon fontSize="small">refresh</Icon>
                        </IconButton>
                      </div>
                    </SuiBox>
                    <div className="pt-2">
                      {/*<SuiTypography variant="body1" textTransform="capitalize" sx={{ my: 2, ml: 2 }}>
                      {currentProjectStatus.label + " Chats"}
                      </SuiTypography>*/}
                      <ul className="overflow-auto h-[27.6rem]">
                        <li>
                          {roomlist.map((room) => {
                            if (room.status > 0) return null;
                            if (room.hidets > room.ts) return null;
                            let lastcontent = room.lastcontent;
                            let dt = smartdate.format(new Date(room.ts));
                            return (
                              <a
                                key={room.id}
                                className={`flex items-center px-3 py-2 transition duration-150 ease-in-out border-b border-gray-300 cursor-pointer focus:outline-none ${
                                  room.id == currentRoom?.id ? "active bg-gray-100" : ""
                                }`}
                                onClick={() => {
                                  setCurrentRoom(room);
                                }}
                              >
                                <Badge
                                  variant="dot"
                                  color="error"
                                  invisible={room.ts <= room.viewts}
                                >
                                  <ContactAvatar room={room} />
                                </Badge>
                                <div className="w-full pb-2 ml-1">
                                  <div className="flex justify-between items-center">
                                    <SuiBox display="flex">
                                      <SuiTypography
                                        variant="button"
                                        className={`block text-gray-600 ${
                                          room.id == currentRoom?.id ? "font-bold" : "font-semibold"
                                        }`}
                                      >
                                        {room.name}
                                      </SuiTypography>
                                      <Link
                                        to={
                                          room.regardingownerid == userid
                                            ? `/produce/all-projects?id=${room.regardingid}`
                                            : `/job/requests?id=${room.regardingid}`
                                        }
                                        target="_blank"
                                        style={{ color: "inherit" }}
                                      >
                                        <SuiTypography variant="button" sx={{ ml: 1 }}>
                                          (
                                          <SuiTypography
                                            sx={{ textDecoration: "underline" }}
                                            display="inline"
                                            variant="button"
                                          >
                                            {room.regardingname}
                                          </SuiTypography>
                                          )
                                        </SuiTypography>
                                      </Link>
                                    </SuiBox>
                                    <SuiTypography
                                      variant="caption"
                                      className={`block text-gray-600 ${
                                        room.id == currentRoom?.id ? "font-bold" : ""
                                      }`}
                                    >
                                      {dt}
                                    </SuiTypography>
                                  </div>
                                  <div className="flex justify-between">
                                    <SuiTypography
                                      className={`text-gray-600 ${
                                        room.id == currentRoom?.id ? "font-bold" : ""
                                      }`}
                                      variant="caption"
                                      textTransform="none"
                                      sx={{
                                        width: "100%",
                                        minHeight: "32px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: "2",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {lastcontent}
                                    </SuiTypography>
                                    <RenderChatMenu
                                      userid={userid}
                                      chatdata={room}
                                      parentReload={reloadChats}
                                    />
                                  </div>
                                </div>
                              </a>
                            );
                          })}
                        </li>
                      </ul>
                    </div>
                  </div>
                </Card>
              </TabPane>
              <TabPane
                tab={
                  <Badge
                    color="error"
                    badgeContent={msgcounter["gcount"]}
                    size="xs"
                    invisible={msgcounter["gcount"] <= 0}
                  >
                    <SuiTypography variant="body1" textTransform="capitalize">
                      General chats
                    </SuiTypography>
                  </Badge>
                }
                key="general"
              >
                <Card className="medium:col-span-1 small:col-span-1 xsmall:col-span-3 overflow-hidden p-2">
                  {/*<RenderAccountTypeMenu />*/}
                  <SuiBox display="flex justify-between" alignItems="center">
                    <div className="w-full pr-3 flex items-center">
                      <SuiSelect
                        size="small"
                        placeholder="Select contact to chat"
                        value=""
                        className="grow"
                        options={contactlist.map((contact) => ({
                          value: contact.id,
                          label: contact.name + " (" + contact.email + ")",
                        }))}
                        onChange={async (contact) => {
                          if (contact) {
                            try {
                              const { data } = await api.chatroom.addChatRoom({
                                userids: [contact.value],
                              });
                              setCurrentRoom(data);
                            } catch (err) {
                              toast.error(`addChatRoom failed!`);
                              console.log(err);
                            }
                          }
                        }}
                      />
                      <Tooltip title="New group">
                        <IconButton
                          size="small"
                          variant="button"
                          color="inherit"
                          onClick={() => {
                            setNewGroupVisiable(true);
                          }}
                        >
                          <AddCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <NewGroupPrompt visible={newGroupVisiable} setVisible={setNewGroupVisiable} />
                      <IconButton
                        size="small"
                        variant="button"
                        color="inherit"
                        onClick={() => {
                          reloadChats();
                          reloadContacts();
                        }}
                      >
                        <Icon fontSize="small">refresh</Icon>
                      </IconButton>
                    </div>
                  </SuiBox>
                  <div className="pt-2">
                    <ul className="overflow-auto h-[29.5rem]">
                      <li>
                        {roomlist.map((room) => {
                          if (room.status > 0) return null;
                          if (room.hidets > room.ts) return null;
                          if (
                            room.totalmsgcnt == 0 &&
                            room.contacts.length == 2 &&
                            room.id != currentRoom?.id
                          )
                            return null;
                          let lastcontent = room.lastcontent;
                          let dt = smartdate.format(new Date(room.ts));
                          return (
                            <a
                              key={room.id}
                              className={`flex items-center px-3 py-2 transition duration-150 ease-in-out border-b border-gray-300 cursor-pointer focus:outline-none ${
                                room.id == currentRoom?.id ? "active bg-gray-100" : ""
                              }`}
                              onClick={() => {
                                setCurrentRoom(room);
                              }}
                            >
                              <Badge variant="dot" color="error" invisible={room.ts <= room.viewts}>
                                <ContactAvatar room={room} />
                              </Badge>
                              <div className="w-full pb-2 ml-1">
                                <div className="flex justify-between items-center">
                                  <SuiTypography
                                    variant="button"
                                    className={`block text-gray-600 ${
                                      room.id == currentRoom?.id ? "font-bold" : "font-semibold"
                                    }`}
                                  >
                                    {room.name}
                                  </SuiTypography>
                                  <SuiTypography
                                    variant="caption"
                                    className={`block text-gray-600 ${
                                      room.id == currentRoom?.id ? "font-bold" : ""
                                    }`}
                                  >
                                    {dt}
                                  </SuiTypography>
                                </div>
                                <div className="flex justify-between">
                                  <SuiTypography
                                    className={`text-gray-600 ${
                                      room.id == currentRoom?.id ? "font-bold" : ""
                                    }`}
                                    variant="caption"
                                    textTransform="none"
                                    sx={{
                                      width: "100%",
                                      minHeight: "32px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {lastcontent}
                                  </SuiTypography>
                                  <RenderChatMenu
                                    userid={userid}
                                    chatdata={room}
                                    parentReload={reloadChats}
                                  />
                                </div>
                              </div>
                            </a>
                          );
                        })}
                      </li>
                    </ul>
                  </div>
                </Card>
              </TabPane>
            </Tabs>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            <Card className="medium:col-span-2 small:col-span-2 xsmall:col-span-3">
              <div className="w-full">
                <ChatRoom key={currentRoom?.id} {...currentRoom} parentReload={reloadChats} />
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
    </Card>
  );
};

export const ContactUsPage = ({}) => {
  const [room, setRoom] = useState(null);
  const account = useContext(AccountContext);
  let userid = account.id;
  console.log("userid", userid);

  useEffect(() => {
    if (userid != "UpStyled") {
      api.chatroom.addChatRoom({ userids: ["UpStyled"] }).then(({ data }) => {
        setRoom(data);
        return data;
      });
    }
  }, []);

  return userid != "UpStyled" ? <ChatRoom key={room?.id} {...room} /> : <></>;
};

export default MessagesPage;
